import { usePostHog } from 'posthog-js/react';
import { SyntheticEvent, useState } from 'react';
import { trackAndNavigate } from '../../../Config/libs/analytics';
import { PostHogFeatureFlagEnum } from '../../enum/PostHogEvent.enum';
import { SocialPlatformEnum } from '../../enum/SocialPlatform.enum';
import { OAUTH_NEXT_STORAGE_KEY, readNextParamFromSearch } from '../../utils/safeNextPath';
import { withSignupAttribution } from '../../utils/signupAttribution';

// Key for storing OAuth tracking data in localStorage
export const OAUTH_TRACKING_KEY = 'posthog_oauth_tracking';

export const useSocialRegister = () => {
  const postHog = usePostHog();
  const [isNavigating, setIsNavigating] = useState(false);

  const handleSocialRegister = async (
    _: SyntheticEvent,
    type: SocialPlatformEnum,
  ): Promise<void> => {
    if (isNavigating) return;
    setIsNavigating(true);

    if (type === SocialPlatformEnum.Google) {
      // Preserve any post-signup redirect (e.g. MCP OAuth authorize) across the Google
      // round-trip so AuthCallbackPage replays it, same as useSocialLogin.
      const nextPath = readNextParamFromSearch(window.location.search);
      if (nextPath) {
        sessionStorage.setItem(OAUTH_NEXT_STORAGE_KEY, nextPath);
      } else {
        sessionStorage.removeItem(OAUTH_NEXT_STORAGE_KEY);
      }

      // Store variant in localStorage before OAuth redirect for tracking after success
      const backgroundVariant = postHog.getFeatureFlag(PostHogFeatureFlagEnum.SignupBackgroundTest);
      localStorage.setItem(
        OAUTH_TRACKING_KEY,
        JSON.stringify({
          variant: backgroundVariant,
          provider: 'google',
          timestamp: Date.now(),
          is_registration: true,
        }),
      );

      trackAndNavigate(
        'register_google_click',
        { event_category: 'User Registration', event_label: 'register_form' },
        () => window.location.assign(withSignupAttribution('/login/google-oauth2/')),
      );
    }
  };

  return {
    handleSocialRegister,
    isNavigating,
  };
};
